<template>
  <div v-if="priceData.totalPrice > 0" class="card mb-3">
    <div class="card-header py-2">
      <h6 class="mb-0">Zahlungsmethode</h6>
    </div>
    <div class="card-body p-3">
      <div class="row g-2">
        <div class="col-md-6">
          <div class="payment-method-card" :class="{ 'selected': paymentMethod === 'paypal' }" @click="paymentMethod = 'paypal'">
            <div class="d-flex align-items-center">
              <font-awesome-icon :icon="['fab','paypal']" size="2x" class="text-primary me-3" />
              <div>
                <h6 class="mb-1">PayPal</h6>
                <small class="text-muted">Sichere Online-Zahlung</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="payment-method-card" :class="{ 'selected': paymentMethod === 'bank_transfer' }" @click="paymentMethod = 'bank_transfer'">
            <div class="d-flex align-items-center">
              <font-awesome-icon icon="university" size="2x" class="text-success me-3" />
              <div>
                <h6 class="mb-1">Banküberweisung</h6>
                <small class="text-muted">Rechnung per E-Mail</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  priceData: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['payment-method-changed'])

const paymentMethod = ref('paypal')

watch(paymentMethod, (newValue) => {
  emit('payment-method-changed', newValue)
})
</script>

<style scoped>
.payment-method-card {
  padding: 1rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.payment-method-card:hover {
  border-color: var(--bs-primary);
  background: rgba(13, 110, 253, 0.05);
}

.payment-method-card.selected {
  border-color: var(--bs-primary);
  background: rgba(13, 110, 253, 0.1);
}
</style>
